<template>
    <div>
        <base-modal :isOpen="value" :title="title" @close="close" size="sm">
            <template #body>
                <div class="flex w-full mt-4">
                    <div class="flex justify-start items-center w-full px-2">
                        <label for="">{{ $t('document') | capitalize }}</label>
                    </div>
                </div>
                <div class="flex w-full">
                    <div class="flex justify-center items-center w-full px-2">
                        <v-select :options="documents" class="w-full" label="name" v-model="document" />
                    </div>
                </div>
                <div class="flex mt-4">
                    <div class="flex justify-center items-center w-full px-2">
                        <vs-alert active="true">
                            El documento estara disponible para este proveedor.
                        </vs-alert>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex gap-4">
                    <vs-button color="danger" icon="close" type="flat" @click="close">
                        {{ $t('close') | upperCase }}
                    </vs-button>
                    <vs-button color="success" icon="save" type="flat" @click="submit" :disabled="document == null">
                        {{ $t('save') | upperCase }}
                    </vs-button>
                </div>

            </template>
        </base-modal>
    </div>

</template>

<script setup>
import { ref, watch } from 'vue'
import BaseModal from '@/views/app/components/BaseModal'
import vSelect from 'vue-select'


const props = defineProps({
    value: { type: Boolean, default: false },
    title: { type: String, default: 'Title' },
    documents: { type: Array, default: () => ([]) }
})

const emit = defineEmits(['submit', 'input'])

const document = ref(null)

watch(() => props.value, (newValue) => {
    if (newValue) {
        document.value = null
    }
})

const close = () => {
    emit('input', false)
}

const submit = () => {
    const data = { documentId: document.value.id }
    emit('submit', data)
}

</script>

<style scoped>
::v-deep(.vs__dropdown-menu) {
    max-height: 80px;
    overflow-y: auto;
}
</style>
